import axios from "axios";

export const getAppointmentsPsychological = async (id?: string) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/appointments/${id}`, {
      withCredentials: true,
    })
    .then((response) => response.data);
};
